var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Keyboard',{attrs:{"placeholder":"Zoeken","grab-focus":true},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_c('LedenTable',{attrs:{"zoeken":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }